// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"465f714e","453":"679c1723","455":"59586acb","977":"d9c506ef"}[chunkId] + ".chunk.js";
};